import React from 'react';

const Card = ({ children, className = '' }) => {
  return <section className={`app-card ${className}`.trim()}>{children}</section>;
};

export const CardHeader = ({ eyebrow, title, description, action }) => (
  <header className="app-card__header">
    <div>
      {eyebrow ? <span className="app-card__eyebrow">{eyebrow}</span> : null}
      {title ? <h2 className="app-card__title">{title}</h2> : null}
      {description ? <p className="app-card__description">{description}</p> : null}
    </div>
    {action ? <div className="app-card__action">{action}</div> : null}
  </header>
);

export default Card;
